import React from 'react';
import ContactMolecule from '../../components/molecules/ContactMolecule';
import FirstContentMolecule from "../../components/molecules/FirstContentMolecule";
import FooterMolecule from "../../components/molecules/FooterMolecule";
import MemberInformationMolecules from "../../components/molecules/memberInformationMolecule";
import ProjectInformationMolecules from "../../components/molecules/ProjectInformationMolecule";
import TitleMolcule from "../../components/molecules/TitleMolecule";



export function OffsetTopOne (){
  var offsetTop = document.getElementById("body-content2").offsetTop;
  window.scroll({ 
    behavior: "smooth",
    top: offsetTop - 133,
  });
}
export function OffsetTopTwo (){
  var offsetTop =document.getElementById("body-content3").offsetTop;
  window.scroll({
    behavior: 'smooth',
    top: offsetTop -133
});
}export function OffsetTopThree (){
  var offsetTop =document.getElementById("body-content4").offsetTop;
  window.scroll({
    behavior: "smooth",
    top: offsetTop - 133,
  });
}
export default function Body (){
    return (
      <div>
        {/* body1 */}
        <FirstContentMolecule id="body-content1" />
        {/* body2 */}
        <TitleMolcule text="Team Lab254" id="body-content2" />
        <MemberInformationMolecules />
        {/* body3 */}
        <TitleMolcule
          text="Project"
          subtitleText="팀 랩이오사가 준비하고 있는 프로젝트입니다."
          id="body-content3"
        />
        <ProjectInformationMolecules />
        {/* body4 */}
        <TitleMolcule
          text="Contact"
          subtitleText="투자, 개발, 제휴 관련 문의는 언제든지 환영합니다 🤝"
          id="body-content4"
        />
        <ContactMolecule />
        <FooterMolecule />
      </div>
    );
}

